// Configuração do Stripe
// Usa variável de ambiente - nunca hardcode chaves de API!
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY || '';

export const STRIPE_CONFIG = {
  publishableKey: STRIPE_PUBLISHABLE_KEY,
  locale: 'auto' as const,
  currency: 'chf'
};
